// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_33tzv","container":"_28DYE","isCentered":"_368Ue","alwaysLtr":"_2njpn","buttonWrapper":"_2rK8V","button":"_1IYeV"};